import { render, staticRenderFns } from "./month.vue?vue&type=template&id=48224ac6"
import script from "./month.vue?vue&type=script&lang=js"
export * from "./month.vue?vue&type=script&lang=js"
import style0 from "./month.vue?vue&type=style&index=0&id=48224ac6&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports